export default "__VITE_ASSET__NaTb2Q2g__"